function addValidationStateToShortDescription(validationState, shortDescription, t) {
  let suffix = null;
  if (validationState === "correct") {
    suffix = t("validation-correct", void 0, "(Correct)");
  } else if (validationState === "incorrect") {
    suffix = t("validation-incorrect", void 0, "(Incorrect)");
  } else if (validationState === "partialcorrect") {
    suffix = t(
      "validation-partially-correct",
      void 0,
      "(Partially correct)"
    );
  }
  if (suffix === null) {
    return shortDescription;
  }
  return (shortDescription ? shortDescription + " " : "") + suffix;
}
export {
  addValidationStateToShortDescription as a
};
